import { prefix } from "../../../design-tokens/meta";

export const componentName = "TableRow";

export const componentClasses = Object.freeze({
    basic: `${prefix}tr`,
});

export const views = Object.freeze({
    rest: {
        attrs: { role: "row" },
        classList: [componentClasses.basic],
    },
});
